import { Alert, AlertIcon } from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useCheckIn } from "../../data/occupancy.api";
import QueryStateWrapper from "../QueryStateWrapper";

type Props = {
  deskId?: string;
};

const DeskCheckIn = ({ deskId }: Props) => {
  const { data, isLoading, error } = useCheckIn(deskId);
  const navigate = useNavigate();

  if (data?.checkInStatus === "NOT_BOOKED_BUT_AVAILABLE") {
    navigate(`/book/${data?.locationId}/${deskId}`);
  }

  return (
    <QueryStateWrapper isLoading={isLoading} error={error} data={data}>
      <Alert status="success">
        <AlertIcon />
        You have checked in to this desk successfully!
      </Alert>
    </QueryStateWrapper>
  );
};

export default DeskCheckIn;
